import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GeneralService } from 'src/app/api/config/general.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { constants } from 'src/app/constants';
declare var $: any;

@Component({
  selector: 'app-search-available-bedrooms-extends',
  templateUrl: './search-available-bedrooms-extends.component.html',
  styleUrls: ['./search-available-bedrooms-extends.component.css']
})
export class SearchAvailableBedroomsExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  private thisComponent: SearchAvailableBedroomsExtendsComponent;
  submitted: boolean = false;
  isSearch: boolean = false;

  // variables
  date_checkin: any = moment().format('YYYY-MM-DD');
  date_checkout: any = moment()
    .add(1, 'days')
    .format('YYYY-MM-DD');
  number_nights: any = 1;

  // variables
  typerate_id: any = null;
  typeRateObj: any = null;
  companyAgreementObj: any = null;
  bedrooms: any = [];
  bedroom_selecteds: any = [];

  constructor(
    public fb: FormBuilder,
    private generalService: GeneralService,
    private hotelbookingService: HotelbookingsService,
    public toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.thisComponent = this;
  }

  loadData(typerate_id: any, companyObj: any = null) {
    this.typerate_id = typerate_id;
    this.typeRateObj = this.toolsService.searchArrById(
      typerate_id,
      constants.HOTEL.TYPE_RATES
    );
    this.companyAgreementObj = companyObj;

    this.isSearch = true;
    setTimeout(() => {
      this.generateCalendar();
      // this.generateCalendarCheckin();
      // this.generateCalendarCheckout();

      // <any>$('#time_checkin').attr('disabled', true);
      // <any>$('#time_checkout').attr('disabled', true);
      <any>$('#number_nights').attr('disabled', true);
    }, 100);
  }

  // FUNCTIONS LOADS DATAS

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        startDate: component_.date_checkin,
        endDate: component_.date_checkout,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.date_checkin = start_date;
        component_.date_checkout = end_date;
        component_.number_nights = end_date.diff(start_date, 'days');
        component_.availableBedrooms();
      }
    );
  }

  // generateCalendarCheckin() {
  //   // datos para fecha de ingreso ==========
  //   let component_ = this.thisComponent;
  //   this.item.patchValue({
  //     date_checkin: moment().format('YYYY-MM-DD')
  //   });
  //   (<any>$('#date_checkin')).daterangepicker(
  //     {
  //       singleDatePicker: true,
  //       autoUpdateInput: false,
  //       showDropdowns: true,
  //       autoApply: true,
  //       locale: {
  //         format: 'YYYY-MM-DD'
  //       }
  //     },
  //     function(chosen_date: any) {
  //       (<any>$('#date_checkin')).val(chosen_date.format('YYYY-MM-DD'));
  //       component_.setDateCheckin(chosen_date.format('YYYY-MM-DD'));
  //       component_.setDateCheckout(
  //         moment(chosen_date)
  //           .add(1, 'days')
  //           .format('YYYY-MM-DD')
  //       );
  //       setTimeout(() => {
  //         component_.generateCalendarCheckout();
  //       }, 150);
  //     }
  //   );
  // }

  // generateCalendarCheckout() {
  //   let component_ = this.thisComponent;
  //   this.item.patchValue({
  //     date_checkout: moment(this.item.value.date_checkin)
  //       .add(1, 'days')
  //       .format('YYYY-MM-DD')
  //   });
  //   (<any>$('#date_checkout')).val(this.item.value.date_checkout);
  //   (<any>$('#date_checkout')).daterangepicker(
  //     {
  //       singleDatePicker: true,
  //       autoUpdateInput: false,
  //       showDropdowns: true,
  //       autoApply: true,
  //       startDate: moment(this.item.value.date_checkin).add(1, 'days'),
  //       minDate: moment(this.item.value.date_checkin).add(1, 'days'),
  //       locale: {
  //         format: 'YYYY-MM-DD'
  //       }
  //     },
  //     function(chosen_date: any) {
  //       (<any>$('#date_checkout')).val(chosen_date.format('YYYY-MM-DD'));
  //       component_.setDateCheckout(chosen_date.format('YYYY-MM-DD'));
  //       component_.calculateNumberNights();
  //     }
  //   );
  // }

  // setDateCheckin(date_assigned: any) {
  //   this.item.patchValue({
  //     date_checkin: date_assigned
  //   });
  // }

  // setDateCheckout(date_assigned: any) {
  //   this.item.patchValue({
  //     date_checkout: date_assigned
  //   });
  // }

  // calculateNumberNights() {
  //   var date_checkout = moment((<any>$('#date_checkout')).val(), 'YYYY-MM-DD');
  //   var date_checkin = moment((<any>$('#date_checkin')).val(), 'YYYY-MM-DD');
  //   this.item.patchValue({
  //     number_nights: date_checkout.diff(date_checkin, 'days')
  //   });
  // }

  selectedBedrooms(item_: any) {
    let validate_ = this.toolsService.notExistObjInArr(
      item_,
      this.bedroom_selecteds
    );
    console.log(item_);
    if (validate_) {
      
      item_.detail_charges = [];
      // capacidad de personas
      item_.nro_pax = item_.roomtype.capacity;
      //  ===========
      this.bedroom_selecteds.push(item_);
    } else {
      let index = this.bedroom_selecteds.indexOf(item_);
      this.bedroom_selecteds.splice(index, 1);
    }
  }

  availableBedrooms() {
    let partnercompany_id = null;
    if (this.companyAgreementObj != null) {
      partnercompany_id = this.companyAgreementObj.id;
    }
    let val_params =
      'start_range=' +
      this.date_checkin.format('YYYY-MM-DD') +
      '&end_range=' +
      this.date_checkout.format('YYYY-MM-DD') +
      '&rate_type=' +
      this.typeRateObj.value +
      '&partnercompany_id=' +
      partnercompany_id;

    this.bedroom_selecteds = [];
    this.hotelbookingService.availableBedroom(val_params).subscribe({
      next: (data: any) => {
        this.bedrooms = data.results;
      }
    });
  }

  onSubmit() {
    (<any>$('#openExtendsAvailableBedrooms')).modal('hide');
    let data: any = {};
    data.id = null;
    data.date_checkin = this.date_checkin.format('YYYY-MM-DD');
    data.date_checkout = this.date_checkout.format('YYYY-MM-DD');
    data.number_nights = this.number_nights;

    for (let i in this.bedroom_selecteds) {
      this.bedroom_selecteds[i].date_checkin = this.date_checkin.format(
        'YYYY-MM-DD'
      );
      this.bedroom_selecteds[i].date_checkout = this.date_checkout.format(
        'YYYY-MM-DD'
      );
      this.bedroom_selecteds[i].number_nights = this.number_nights;
    }

    data.bedroom_selecteds = this.bedroom_selecteds;
    this.onSubmitEvent.emit(data);
    this.close();
  }

  resetForm() {
    this.submitted = false;
  }

  close() {
    this.bedrooms = [];
    this.bedroom_selecteds = [];
    this.date_checkin = moment().format('YYYY-MM-DD');
    this.date_checkout = moment()
      .add(1, 'days')
      .format('YYYY-MM-DD');
  }
}
